import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import shortid from 'shortid';
import classNames from 'classnames';
import ReactGA from 'react-ga';

import Wait from './Wait';
import Button from './Button';
import ExtraQuestion from './ExtraQuestion';

class Questionnaire extends Component {
  state = {
    isButtonPressed: false,
    isButton0Active: false,
    isButton1Active: false
  }

  render() {
    const {
      tests,
      responses,
      emotion,
      collectResponse,
      createResult,
      addUserExtraResponse,
      match,
      history
    } = this.props;

    const testId = match.params.testId;
    const questions = tests[parseInt(testId, 10) - 1];
    const nextTestId = testId === '9' ? 'wait' : parseInt(testId, 10) + 1;

    if (testId === 'wait') {
      return (
        <Wait history={history} />
      );
    } else if (testId === '10') {
      return (
        <ExtraQuestion
          createResult={createResult}
          addUserExtraResponse={addUserExtraResponse}
          history={history}
          responses={responses}
          emotion={emotion}
        />
      );
    }

    return (
      <div className="container full-width fixed">
        <div className="container">
          <div className="row margin-top-lg margin-sm-top-xl margin-lg-top-xxl">
            {questions.map((q, i) =>
              <div
                key={`q-${testId}-${i}`} // eslint-disable-line react/no-array-index-key
                className={classNames(
                  'col-xs-5',
                  'col-sm-3',
                  // 'col-md-2',
                  'text-center',
                  { 'col-xs-offset-1': i === 0 },
                  { 'col-sm-offset-3': i === 0 },
                  // { 'col-md-offset-4': i === 0 }
                )}
              >
                <div className="choice">
                  <Button
                    className={classNames(
                      'btn',
                      'btn-round'
                    )}
                    data-tag={q.tag}
                    onClick={
                      () => {
                        console.log('on click');
                        if (!this.state.isButtonPressed) {
                          this.setState({ isButtonPressed: true });

                          const { tag } = q;
                          const end = (new Date()).getTime();
                          const theOther = questions[1 - i].tag;

                          let isTheLastTest = false;

                          if (parseInt(testId, 10) === tests.length) {
                            isTheLastTest = true;
                          }

                          ReactGA.event({
                            category: 'Choice',
                            action: 'Answer',
                            label: tag
                          });
                          console.log('ga sent');

                          collectResponse({
                            testId: parseInt(testId, 10),
                            tag,
                            end,
                            theOther
                          }, isTheLastTest);
                          console.log('push', `/test/${nextTestId}`);
                          history.push(`/test/${nextTestId}`);
                        }
                      }
                    }
                  >
                    {q.text}
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

Questionnaire.propTypes = {
  tests: PropTypes.arrayOf(
    PropTypes.array.isRequired
  ).isRequired,
  responses: PropTypes.arrayOf(
    PropTypes.object.isRequired
  ).isRequired,
  emotion: PropTypes.string.isRequired,
  collectResponse: PropTypes.func.isRequired,
  addUserExtraResponse: PropTypes.func.isRequired,
  createResult: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.object.isRequired
  }).isRequired,
  history: PropTypes.shape().isRequired
};

export default Questionnaire;



// WEBPACK FOOTER //
// ./app/components/Questionnaire.js